
//资源库首页最新上传
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
import {Empty, Select, Tabs} from "antd";
import File from './File'
import Detailpage from "../../../components/DetailPage";
import {uuid} from "../../../../../utils";
import {message} from "../../../components/Mess";

const { TabPane } = Tabs;
export default class ResourceData  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            typeList:[
                {name: '图片', type: 'picture'},
                {name: '视频', type: 'video'},
                {name: '音频', type: 'audio'},
                {name: '其他', type: 'other_file'},
            ],
            page:1,
            size:14,
            dataSource:[],
            indexName:'picture'
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
        this.getList()
    }

    render() {

        return(
           <div style={{width: "60%",background:'#ffffff',height:'428px',borderRadius: "10px",padding:'20px 40px', overflow: "hidden",}} id={'resourceDataTree'}>
               {this.renderTable()}
               {this.renderData()}
           </div>
        )
    }
    //渲染table
    renderTable(){
        return(
            <div style={{display:'flex',alignItems: "center"}}>
                <div style={{fontSize:'20px',color:'rgba(0,0,0,0.85)',fontWeight: 500}}>最新上传</div>
                <Tabs style={{marginLeft:'10px'}} activeKey={this.state.indexName}  onChange={(value) => this.handleChange(value)}>
                    {this.state.typeList&&this.state.typeList.length&&this.state.typeList.map((item,index)=>{
                        return(
                            <TabPane tab={item.name}   key={item.type} ></TabPane>
                        )
                    })}
                </Tabs>
                <style>{`#resourceDataTree .ant-tabs-bar {border-bottom: 0px solid #e8e8e8 !important}
                        #resourceDataTree .ant-tabs-ink-bar { background-color: #ffffff !important}
                       #resourceDataTree .ant-tabs-nav .ant-tabs-tab{margin:0;padding: 12px}
                       #resourceDataTree .ant-tabs{color:rgba(0,0,0,0.45)!important}
                   `}</style>
            </div>
        )
    }
    //渲染table
    renderData(){
        let {dataSource} =this.state;
        return (
            <div>
                {
                    dataSource&&dataSource.length>0?<div  style={{
                        marginTop:'20px',
                        display:'grid',
                        justifyContent: 'space-between',
                        padding:'0px 40px 0px 0px',
                        columnGap: '30px',
                        rowGap:'30px',
                        overflow: "hidden",
                        height: "300px",
                        gridTemplateColumns:' repeat(auto-fill, 88px)',
                    }}>{dataSource.map((item,index)=>{
                        return  <File file={item} key={item.id} onClick={()=>{
                            this.itemClick(item,index)
                        }} download={()=>{
                          
                            this.downLoad(item)
                        }}></File> })}
                        </div>: <Empty style={{margin: "100px auto"}}/>

                }
                <Detailpage  key={this.state.modalKey} onRef={ref => this.setDetailpage = ref} onCloseCall={()=>{this.setState({modalKey:uuid()})}} dataList={this.state.dataSource}></Detailpage>
            </div>
        )
    }
    itemClick(item,index){
        console.log(this)
        let status=item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download:false
        if(!status){
            this.setDetailpage.show(true, item,index)
        }else{
            message.error("您没有所选资源的使用权限，请申请下载！")
        }

    }
    //下载
    downLoad=(record)=>{

        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body:{virtualFileId:record.id,name:record.name, downloadFlag:false},
            contentType:'json',
            callBack: (data) => {
                if(data){
                    let url =  "/storage/downloadFile?md5="+record.md5+'&download=1';
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download','');
                    aObj.setAttribute('href',url);
                    aObj.click();
                    aObj = null
                }
            }
        });
    }
    //切换tab
    handleChange=(value)=>{
        console.log(value,'========')
       this.setState({indexName:value},()=>{this.getList()})
    };
    //获取数据
    getList() {
        let parms ={
            pageNum: this.state.page,
            pageSize:this.state.size,
        };
        let {indexName} =this.state;
        this.request({
            url: `/search-server/search/getList/${indexName}/dept`,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                let dataSource = [];
                if (data && data.data && data.data.length) {
                    dataSource = data.data
                }
                this.setState({dataSource:dataSource})

            }
        });
    };
}
